/**
 * @file 使用 raf 设置定时器
 * @author FengGuang(fengguang01@baidu.com)
 *
 */
type ISetIntervalRafCallback = (cancel: () => void) => void;

const setIntervalRaf = (callback: ISetIntervalRafCallback, ms: number = 0) => {
    let isRunning = true;
    let time = ms > 0 ? Date.now() : 0;

    const cancel = () => {
        isRunning = false;
    };

    const run = () => {
        if (isRunning) {
            if (ms > 0) {
                let current = Date.now();
                if (current - time > ms) {
                    callback(cancel);
                }
                time = current;
            }
            else {
                callback(cancel);
            }
            requestAnimationFrame(run);
        }
    };
    run();
    return {
        cancel
    };
};

export default setIntervalRaf;
